import React from 'react';
import {
  SavedPropertyFilterTabType,
  SavedPropertyFilterType,
} from '~/types/activitiesTypes';
import Sort from '~activities/pages/Favorites/Sort';

const FavoritesFilter = ({
  tabs,
  activeTab,
  setActiveTab,
  filterState,
  setFilterState,
}: {
  tabs: {
    key: SavedPropertyFilterTabType;
    label: string;
    count: number;
    hide?: boolean;
  }[];
  activeTab: SavedPropertyFilterTabType;
  setActiveTab: React.Dispatch<
    React.SetStateAction<SavedPropertyFilterTabType>
  >;
  filterState: SavedPropertyFilterType;
  setFilterState: React.Dispatch<React.SetStateAction<SavedPropertyFilterType>>;
}) => {
  const totalTabs = tabs.reduce((acc, tab) => acc + (tab.hide ? 0 : 1), 0);
  return (
    <div className="px-2x md:px-0 flex gap-2x md:gap-2x flex-row-reverse md:flex-row items-center justify-between border-b md:border-0 border-gray pb-[20px] md:pb-0">
      <div className="relative flex-1 flex items-center gap-1.5x overflow-hidden md:ps-0 h-[40px] ps-2x">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;

          if (tab.hide) return null;

          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => {
                setActiveTab(tab.key);
              }}
              className={[
                `${totalTabs > 1 ? 'flex-1 md:flex-grow-0' : 'max-w-[220px]'}  rounded-[12px] border px-2x py-x text-caption-1 md:text-body-2 transition-colors whitespace-nowrap h-[40px]`,
                isActive
                  ? 'border-blue_light_2 bg-blue_light_2 text-blue'
                  : 'border-gray text-gray__dark_2 hover:bg-blue_light_2 hover:border-blue_light_2 hover:text-blue',
              ].join(' ')}
            >
              {`${tab.label} (${tab.count})`}
            </button>
          );
        })}
        <span className="absolute -translate-y-1/2 start-0 top-1/2 h-[32px] w-[1px] bg-gray md:hidden"></span>
      </div>
      <Sort filterState={filterState} setFilterState={setFilterState} />
    </div>
  );
};

export default FavoritesFilter;
